export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/85e451a359bc766caa0076eab2c719aa.jpg"
          alt="NURA DOO background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/55 to-black/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-32">
        <div className="max-w-2xl">
          {/* Label */}
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-cyan-400" />
            <span className="text-cyan-400 text-xs uppercase tracking-[0.25em] font-medium">
              iOS Development Studio
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-light leading-[1.08] text-white mb-8" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Modern Apps
            <br />
            <span className="font-semibold">for the iOS</span>
            <br />
            <span className="text-cyan-400 font-semibold">Platform</span>
          </h1>

          {/* Description */}
          <p className="text-white/70 text-lg leading-relaxed max-w-xl mb-6">
            NURA DOO is a team of experts crafting premium iOS applications that
            put user experience and device security at the forefront.
          </p>
          <p className="text-white/55 text-base leading-relaxed max-w-lg">
            Our products — VPN and Cleaner — are engineered to deliver
            performance, privacy, and peace of mind to mobile users worldwide.
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-white/40 to-transparent animate-pulse" />
      </div>
    </section>
  );
}
